import { post } from '@/utils/request'

/**
 * 饿了么外卖统计
 * @param {object} data 请求参数
 * @param {string} data.date_from 开始统计时间（默认是1个月之前，开始和结束不能超过60天）
 * @param {string} data.date_to 结束统计时间（默认是今日）
 */
export default function taoke_ele_report(data) {
  return post('taoke_ele_report', data)
}